<div class="container">
    <div class="row mt-5 change-phone-box" *ngIf="!showVerificationBox">
        <div class="col-sm-12">
            <p class="title col-sm-12">Reset Password</p>
        </div>
        <div class="col-sm-12">
            <div class="form-group col-sm-12">
                <p class="hint m-1">Enter your phone number. We will sent verification code to your phone.</p>
                <input class="form-control" [formControl]="phone" placeholder="Mobile Number">
                <p class="error m-1" *ngIf="phone.errors && phone.errors.required">Mobile Number is required!!</p>
            </div>
            <div class="col-sm-12 mt-2">
                <p class="text-right mr-0"><button mat-raised-button (click)="requestPasswordChange()" [disabled]="phone.invalid">Reset Password</button></p>
            </div>
        </div>
    </div>
    <div class="row mt-5 mb-5 justify-content-center" *ngIf="showVerificationBox">
        <div class="card shadow">
            <div class="card-body">
                <h5 class="card-title text-center mt-3">Verify your phone</h5>
                <mat-divider class="mt-3 mb-3"></mat-divider>
                <p class="col-sm-12 text-center">Please enter the 4-digit verification code we sent via SMS</p>
                <form (ngSubmit)="onSubmit()" [formGroup]="form">
                    <div class="form-group col-sm-12 text-center row m-auto">
                        <div class="form-group col-sm-3" *ngFor="let input of formInput;  index as i">
                            <input OnlyNumber="true" #formRow type="text" (keypress)="numberOnly($event)" formControlName="{{input}}" class="form-control" maxlength="1" (keyup)="goToNextInput($event, i)">
                        </div>
                        <div class="col-sm-12">
                            <button [disabled]="form.invalid" class="mt-3" type="submit">Verify</button>
                        </div>
                    </div>
                </form>
                <p class="col-sm-12 text-center small mt-3">It might take some time to receive the message. Please be patient.</p>
            </div>
        </div>
    </div>
</div>